import { render } from "./AboutPageUxSection.vue?vue&type=template&id=7064d406&scoped=true"
import script from "./AboutPageUxSection.vue?vue&type=script&lang=js"
export * from "./AboutPageUxSection.vue?vue&type=script&lang=js"

import "./AboutPageUxSection.vue?vue&type=style&index=0&id=7064d406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7064d406"]])

export default __exports__